import ClipboardJS from 'clipboard';

function clipboardTrigger(copylink) {
  const clipboard = new ClipboardJS(copylink);
  const icon = copylink.querySelector('.fa-link');

  clipboard.on('success', (e) => {
    icon.classList.toggle('fa-link');
    icon.classList.toggle('fa-check');
    setTimeout(() => {
      icon.classList.toggle('fa-link');
      icon.classList.toggle('fa-check');
    }, 1000);
    e.clearSelection();
  });

  return clipboard;
}

const clipboardInit = (copylink: HTMLElement) => clipboardTrigger(copylink);

export default clipboardInit;
